/**
 * ChannelCustom entity class
 */

/**
 * ChannelCustomFactory
 * returns ChannelCustom entity class
 *
 * @class ChannelCustomFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ChannelCustom} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ChannelCustomFactory
 */
/* @ngInject */
export default function ChannelCustomFactory (Channel) {
  /* === ChannelCustom class === */

  /**
   * ChannelCustom model
   *
   * @class ChannelCustom
   * @classdesc ChannelCustom model
   * @memberof models
   * @see models
   * @extends models.Channel
   * @return {models.ChannelCustom} ChannelCustom entity
   */
  function ChannelCustom () {
    var obj = Channel.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ChannelCustom.prototype = Object.create(Channel.prototype)
  ChannelCustom.prototype.constructor = ChannelCustom

  /* === ChannelCustom instance methods & fields === */

  Object.assign(ChannelCustom.prototype, {
    /**
     * instance fields
     *
     * @memberof models.ChannelCustom#
     * @type {Object}
     */
    _fields: {
      ...Channel.prototype._fields,
      channel: 'Channel',
      $order: Boolean
    },


    /**
     * On/Off Entity, performing PATCH request to the server
     *
     * @memberof models.Channel#
     * @param {Boolean} [enabled=this.enabled] - enable or disable Entity
     * @return {Promise} promise
     */
    _onOff: function (enabled) {
      if (typeof enabled !== 'boolean') {
        enabled = this.$order
      }

      return this._patch(this._url, enabled ? '"First"' : '"Last"')
        .catch(rejection => {
          this.$order = !this.$order
          return rejection
        })
    },

    /**
     * url template
     *
     * @memberof models.ChannelCustom#
     * @type {String}
     */
    _urlTemplate: 'api/subscribers/{{::subscriber.id}}/channels/{{::channel.id}}',

    /**
     * public url template,
     *
     * @memberof models.ChannelCustom#
     * @type {String}
     */
    _publicUrlTemplate: 'subscribers/{{::subscriber.id}}/customstreams/' +
                        '{{::id ? channelType.toLowerCase() + "/" : "#" + channelType.toLowerCase()}}{{::id}}'

  })

  /* === ChannelCustom static methods & fields === */

  // copy all static methods from Channel class
  Object.assign(ChannelCustom, Channel)
  ChannelCustom._name = 'ChannelCustom'
  ChannelCustom._publicName = 'Custom Channel'
  ChannelCustom.init()

  // permissions
  ChannelCustom.access = {
    view: 'viewSubscriberCustomStream viewChannel | createCatchup | editCatchup | editNetwork | editCategory |',
    create: 'createSubscriberCustomStream',
    edit: 'editSubscriberCustomStream',
    delete: 'deleteSubscriberCustomStream'
  }

  return ChannelCustom
}
